import { applyMiddleware, combineReducers, createStore } from 'redux';
import appWindow from '@utils/AppWindow/app-window.redux.reducers';
import navMenu from '@App/components/Navbar/NavMenu/nav-menu.redux.reducers';

const reducers = combineReducers({ 
  appWindow,
  navMenu,
});

const createStoreArgs = [reducers];

if (import.meta.env.DEV) {
  const { createLogger } = await import('redux-logger');
  const logger = createLogger({
    collapsed: (_getState, _action, logEntry) => !logEntry.error,
  });

  createStoreArgs.push(applyMiddleware(logger));
}

export default createStore(...createStoreArgs);